import {
  Component,
  OnInit,
  Input,
  ViewChildren,
  QueryList,
  AfterViewInit,
  ChangeDetectorRef,
} from "@angular/core";
import { Subscription } from "rxjs";
import { EpgItem, Program } from "../../../data/btv/model/epg-item";
import { DatePipe } from "@angular/common";
import { BtvDataRestService } from "../../../data/btv/btv-data-rest.service";
import { DeviceDetectorService } from "ngx-device-detector";

declare var Glider: any;
declare var $: any;

@Component({
  selector: "app-channel-epg",
  templateUrl: "./channel-epg.component.html",
  styleUrls: ["./channel-epg.component.css"],
})
export class ChannelEpgComponent implements OnInit, AfterViewInit {
  @Input() channelID: number;
  @ViewChildren("carouselItems") carouselItems: QueryList<any>;
  @ViewChildren("programItems") programItems: QueryList<any>;

  now: number = Date.now();
  oneDay: number = 86400000;
  days: number[] = [];
  epgDaySubscription: Subscription;
  epgProgramSubscription: Subscription;
  epgDayGlider: any;
  epgProgramGlider: any = null;
  selectedDay: number;
  dailyEpgPrograms: Program[] = [];
  nowPlayingIndex: number;
  noProgramData: boolean = false;
  isMobile: boolean;
  isTablet: boolean;
  isDesktop: boolean;
  nowPlayingProgram: Program = {};
  epgDaysDiv: HTMLElement;
  selectedProgram: Program = {};
  startClientX: number;
  isScrolling: boolean = false;

  constructor(
    private datePipe: DatePipe,
    private dataSource: BtvDataRestService,
    private deviceService: DeviceDetectorService,
    private cdRef: ChangeDetectorRef
  ) {
    this.isMobile = deviceService.isMobile();
    this.isTablet = deviceService.isTablet();
    this.isDesktop = deviceService.isDesktop();
  }

  ngOnInit() {
    let today = this.datePipe.transform(this.now, "yyyy-MM-dd, h:mm");
  }

  ngAfterViewInit() {
    this.calcDays();
    this.epgDaysDiv = document.getElementById("epg-days");
    this.cdRef.detectChanges();
  }

  calcDays() {
    this.days = [];
    for (
      var i = this.now - 7 * this.oneDay;
      i <= this.now + 7 * this.oneDay;
      i = i + this.oneDay
    ) {
      if (this.now >= i && this.now < i + this.oneDay) {
        this.selectedDay = i;
      }

      this.days.push(i);
    }

    this.epgDayCarouselInit();
  }

  epgDayCarouselInit() {
    this.epgDaySubscription = this.carouselItems.changes.subscribe((t) => {
      this.epgDayGlider = new Glider(
        document.querySelector("#epg-day-glider"),
        {
          slidesToShow: 9.5,
          slidesToScroll: 1,
          draggable: true,
          rewind: true,
          duration: 1.2,
          dragVelocity: 1,
          responsive: [
            {
              // screens greater than >= 1024px
              breakpoint: 1350,
              settings: {
                slidesToShow: 9.2,
                slidesToScroll: 1,
              },
            },
            {
              // screens greater than >= 479px
              breakpoint: 479,
              settings: {
                slidesToShow: 4.6,
                slidesToScroll: 1,
              },
            },
            {
              // screens greater than >= 479px
              breakpoint: 0,
              settings: {
                slidesToShow: 2.5,
                slidesToScroll: 1,
              },
            },
          ],
        }
      );
    });

    setTimeout(() => {
      this.scrollToSelectedItem();
      this.getDailyEpg();
    }, 100);
  }

  selectDay(day: number) {
    if (day != this.selectedDay && !this.isScrolling) {
      this.selectedDay = day;
      this.getDailyEpg();
    }
  }

  scrollToSelectedItem() {
    if (this.isMobile) {
      this.epgDayGlider.scrollItem(this.days.indexOf(this.selectedDay) - 1);
    } else if (this.isTablet) {
      this.epgDayGlider.scrollItem(this.days.indexOf(this.selectedDay) - 2);
    } else {
      this.epgDayGlider.scrollItem(this.days.indexOf(this.selectedDay) - 4);
    }
    const gliderContainer = document.getElementById("epg-day-glider");
    gliderContainer.addEventListener("mousedown", (event) => {
      // Mouse aşağıya basıldığında, başlangıç scroll değerini kaydediyoruz
      this.startClientX = event.clientX;
      setTimeout(() => {
        gliderContainer.addEventListener("mousemove", onMouseMove);
      }, 150);
    });

    const onMouseMove = (event) => {
      // Mouse hareket ettikçe, başlangıç scroll değeri ile mevcut scroll değeri arasındaki farkı hesaplıyoruz
      const scrollDelta = Math.abs(event.clientX - this.startClientX);

      // Eğer scroll farkı belirli bir eşik değerini aşıyorsa, istediğimiz işlemi gerçekleştiriyoruz
      if (scrollDelta > 10) {
        this.isScrolling = true;
        //console.log("Belirli bir miktar kaydırıldı!");
        gliderContainer.removeEventListener("mousemove", onMouseMove);
      }
    };

    gliderContainer.addEventListener("mouseup", (event) => {
      setTimeout(() => {
        gliderContainer.removeEventListener("mousemove", onMouseMove);
      }, 200);
      if (this.isScrolling) {
        setTimeout(() => {
          this.isScrolling = false;
        }, 150);
      }
    });
  }

  watchedPercantage: number;
  isVisible: boolean;
  isGliderVisible: boolean;
  isClicked: boolean;

  getDailyEpg() {
    this.isClicked = true;
    this.epgDaysDiv.classList.add("clicked");
    this.isGliderVisible = false;
    this.dailyEpgPrograms = [];
    this.dataSource
      .getEpgDataByChannelId(
        this.channelID,
        this.datePipe.transform(this.selectedDay, "yyyy-MM-dd")
      )
      .subscribe((data) => {
        this.epgDaysDiv.classList.remove("clicked");
        var temp = data;
        this.isClicked = false;

        if (temp.length != 0) {
          this.noProgramData = false;

          const foundProgram = temp.find((program) => this.now >= program.startHour && this.now < program.endHour)
          if (foundProgram) {
            this.isVisible = true;
            this.nowPlayingProgram = foundProgram;
            this.nowPlayingIndex = temp.indexOf(foundProgram);
            this.watchedPercantage =
              ((this.now - foundProgram.startHour) /
                (foundProgram.endHour - foundProgram.startHour)) * 100;
          } else {
            this.isVisible = false;
            this.nowPlayingIndex = null;
          }
          // if (
          //   this.datePipe.transform(this.now, "EEEE", "GMT") ==
          //   this.datePipe.transform(this.selectedDay, "EEEE", "GMT")
          // ) {
          //   this.isVisible = true;
          //   temp.forEach((program, index) => {
          //     if (
          //       this.now >= new Date(program.startHour).getTime() &&
          //       this.now < new Date(program.endHour).getTime()
          //     ) {
          //       this.nowPlayingIndex = index;
          //       this.watchedPercantage =
          //         ((this.now - new Date(program.startHour).getTime()) /
          //           (new Date(program.endHour).getTime() -
          //             new Date(program.startHour).getTime())) *
          //         100;
          //       this.nowPlayingProgram = program;
          //     }
          //   });
          // } else {
          //   this.isVisible = false;
          //   this.nowPlayingIndex = null;
          // }

          if (!this.epgProgramSubscription) {
            this.epgProgramCarousel();
          }
          this.isGliderVisible = true;
          // if (!!this.epgProgramGlider) {
          //   // this.epgProgramGlider.destroy();
          // }
        } else {
          this.noProgramData = true;
        }
        temp.sort((a, b) => {
          return a.startHour - b.startHour;
        });
        this.dailyEpgPrograms = temp;
      });
  }

  epgProgramCarousel() {
    this.epgProgramSubscription = this.programItems.changes.subscribe((t) => {
      if (this.isGliderVisible) {
        this.gliderInit();
      }
    });
  }

  gliderInit() {
    this.epgProgramGlider = new Glider(
      document.querySelector("#epg-program-glider"),
      {
        slidesToShow: 6.5,
        slidesToScroll: 1,
        draggable: true,
        rewind: true,
        duration: 1.2,
        dragVelocity: 1,
        responsive: [
          {
            // screens greater than >= 1024px
            breakpoint: 1350,
            settings: {
              slidesToShow: 6.5,
              slidesToScroll: 1,
            },
          },
          {
            // screens greater than >= 479px
            breakpoint: 479,
            settings: {
              slidesToShow: 4.6,
              slidesToScroll: 1,
            },
          },
          {
            // screens greater than >= 479px
            breakpoint: 0,
            settings: {
              slidesToShow: 2.5,
              slidesToScroll: 1,
            },
          },
        ],
      }
    );

    if (this.isVisible) {
      setTimeout(() => {
        document.getElementById("nowplaying").style.width =
          this.watchedPercantage + "%";

        if (this.nowPlayingIndex) {
          //this.scrollToNowProgram();
        }
      }, 200);
    }
  }

  scrollToNowProgram() {
    this.epgProgramGlider.scrollItem(this.nowPlayingIndex);
  }

  selectProgram(program: Program) {
    this.selectedProgram = program;
    $("#modal-program-detail").modal("show");
  }

  selectProgram2(program: Program) {
    if (!this.isDesktop) {
      this.selectedProgram = program;
      $("#modal-program-detail").modal("show");
    }
  }

  ngOnDestroy() {
    if (this.epgDaySubscription) {
      this.epgDaySubscription.unsubscribe();
      this.epgDaySubscription = null;
    }
    if (this.epgProgramSubscription) {
      this.epgProgramSubscription.unsubscribe();
      this.epgProgramSubscription = null;
    }
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/sportstv/client/sportstv-web-client-prod/src/app/views/btv/channel-epg/channel-epg.component.ts